let d = new Date();
d.setHours(14);
d.setMinutes(0);

const initialState = {
  galleryCount: 0,
  galleryPrice: false,
  galleryAllList: [],
  galleryName: false,
  galleryId: false,
  uploadedGid: null,
  uploadGname: null,
  allChecked: false,
  galleryDateTimeInfo: {
    date: new Date().toISOString().substring(0, 10),
    time: d,
    timeDiff: 2,
  },
  pIds: [],
  price: null,
  zoomIndex: 0,
  showSpiner: false,
  drawWidth: 260,
  editGalleryAble: null,
  addingPhotosGallery: null,
  addPhotosPromptGallery: null,
  updateGallery: false,
  mapSearchViewAble: true,
  filterItem: {
    sportTag: false,
    selectedDate: false,
    selectTime: false,
    place: false,
  },
  showDelRes: false,
  selectedGallery: {},
};

export default function Gallery(state = initialState, action) {
  switch (action.type) {
    case "GALLERY/ADDCOUNT":
      return {
        ...state,
        galleryCount: action.galleryCount,
      };
    case "GALLERY/SETGALLERYFILTERITEM":
      return {
        ...state,
        filterItem: action.filterItem,
      };
    case "GALLERY/EDITGALLERYABLE":
      return {
        ...state,
        editGalleryAble: action.editGalleryAble,
      };
    case "GALLERY/ADDINGPHOTOS":
      return {
        ...state,
        addingPhotosGallery: action.addingPhotosGallery,
      };
    case "GALLERY/ADDPHOTOSPROMPT":
      return {
        ...state,
        addPhotosPromptGallery: action.addPhotosPromptGallery,
      };
    case "GALLERY/SETMAPVIEWABLE":
      return {
        ...state,
        mapSearchViewAble: action.mapSearchViewAble,
      };
    case "GALLERY/SETUPDATEGALLEY":
      return {
        ...state,
        updateGallery: action.updateGallery,
      };
    case "GALLERY/ALLCHECKED":
      return {
        ...state,
        allChecked: action.allChecked,
      };
    case "GALLERY/REMOVECOUNT":
      return {
        ...state,
        galleryCount: action.galleryCount,
      };
    case "GALLERY/SETGALLERYPRICE":
      return {
        ...state,
        galleryPrice: action.galleryPrice,
      };
    case "GALLERY/SETGALLERYLIST":
      return {
        ...state,
        galleryAllList: action.galleryAllList,
      };
    case "GALLERY/SETGALLEYDATETIMEINFO":
      return {
        ...state,
        galleryDateTimeInfo: action.galleryDateTimeInfo,
      };
    case "GALLERY/GETPHOTOSBYGALLERY":
      return {
        ...state,
        galleryPhotos: action.galleryPhotos,
      };
    case "GALLERY/GETPIDS":
      return {
        ...state,
        pIds: action.pIds,
      };
    case "GALLERY/SETZOOMINDEX":
      return {
        ...state,
        zoomIndex: action.zoomIndex,
      };
    case "GALLERY/GALLERYNAME":
      return {
        ...state,
        galleryName: action.galleryName,
        galleryId: action.galleryId,
      };
    case "GALLERY/SETPRICE":
      return {
        ...state,
        price: action.price,
      };
    case "GALLERY/SETLOADINGSPINER":
      return {
        ...state,
        showSpiner: action.showSpiner,
      };
    case "GALLERY/SETPERCENTLOADER":
      return {
        ...state,
        percentLoader: action.percentLoader,
      };
    case "GALLERY/SETDRAWWIDTH":
      return {
        ...state,
        drawWidth: action.drawWidth,
      };
    case "GALLERY/SETSHOWDELRES":
      return {
        ...state,
        showDelRes: action.showDelRes,
      };
    case "GALLERY/SETSELECTEDGALLERY":
      return {
        ...state,
        selectedGallery: action.payload,
      };
    default:
      return state;
  }
}
